import { ResourcesConfig } from 'aws-amplify';

export const AmplifyAuthCognitoConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: import.meta.env.VITE_AWS_COGNITO_CLIENT_ID,
      userPoolId: import.meta.env.VITE_AWS_COGNITO_POOLS_ID,
      identityPoolId: import.meta.env.VITE_AWS_COGNITO_IDENTITY_POOL_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_AWS_COGNITO_DOMAIN,
          scopes: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [
            'http://localhost:3000/app/callback',
            'https://saagas.ai/app/callback',
            'https://dev.saagas.ai/app/callback',
            'https://alpha.saagas.ai/app/callback',
            'https://beta.saagas.ai/app/callback',
            'https://prod.saagas.ai/app/callback',
            'https://saagas.ai/app/callback',
            'https://www.saagas.ai/app/callback'
          ],
          redirectSignOut: [
            'http://localhost:3000/',
            'https://saagas.ai/',
            'https://dev.saagas.ai/',
            'https://alpha.saagas.ai/',
            'https://beta.saagas.ai/',
            'https://prod.saagas.ai/',
            'https://saagas.ai/',
            'https://www.saagas.ai/'
          ],
          responseType: 'code'
        }
      }
    }
  }
};
